import React, { PropsWithChildren, useMemo } from 'react';
import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet';
import PageBreadcrumbs, { BreadcrumbItem } from './PageBreadcrumbs';
import PageHeader from './PageHeader';
import Slide from '@mui/material/Slide';
import PageLoader from 'components/PageLoader';

interface PageContainerInterface {
  loading?: boolean;
  heading?: string;
  useHeadingAsPageTitle?: boolean;
  pageTitle?: string;
  refetching?: boolean;
  subheaderComponent?: React.ReactNode;
  breadcrumbs?: Array<BreadcrumbItem>;
  className?: string;
}

const PageContainer: React.FC<PropsWithChildren<PageContainerInterface>> = ({
  loading,
  heading,
  useHeadingAsPageTitle = true,
  pageTitle,
  refetching,
  breadcrumbs,
  children,
  subheaderComponent,
  className,
}) => {
  const documentTitle = useMemo(() => {
    if (pageTitle) return pageTitle;
    if (useHeadingAsPageTitle && heading) return heading;
    return undefined;
  }, [pageTitle, useHeadingAsPageTitle, heading]);

  return loading ? (
    <PageLoader />
  ) : (
    <Slide in={true} direction="up" mountOnEnter unmountOnExit>
      <Box width="100%" height="100%" className={className}>
        {documentTitle && (
          <Helmet>
            <title>{documentTitle}</title>
          </Helmet>
        )}
        {(heading || breadcrumbs) && (
          <PageHeader
            heading={heading}
            refetching={refetching}
            breadcrumbComponent={
              breadcrumbs && <PageBreadcrumbs items={breadcrumbs} />
            }
            subheaderComponent={subheaderComponent}
          />
        )}
        {children}
      </Box>
    </Slide>
  );
};

export default PageContainer;
